<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="'修改'+flagStr"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="form" :inline="true" status-icon label-width="130px" class="query-form" size="mini">
            <el-form-item label="店铺: " class="query-form-item" label-width="165px"
                          v-if="flagStr == '店铺'">
                <el-select
                    v-model="asinInfo.shop_name"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option v-for="item in list" :key="item.id" :label="item.shop_name"
                               :value="item.shop_name"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="负责人：" v-if="flagStr == '负责人'">
                <el-input v-model="asinInfo.person" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入负责人"></el-input>
            </el-form-item>

            <el-form-item label="备注：" v-if="flagStr == '备注'">
                <el-input v-model="asinInfo.remark" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入备注"></el-input>
            </el-form-item>

            <el-form-item label="品牌：" v-if="flagStr == '品牌'">
                <el-input v-model="asinInfo.brand" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入品牌"></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleClose(true)" :loading="loading">确 定</el-button>
          </span>

    </el-dialog>
</template>
<script>
import * as api from '@/api/Product/Product'
import {
    shop_name_list,
    track_asin_index_update_person,
    track_asin_index_update_remark,
    track_asin_index_update_brand,
    track_asin_index_update_shop_name
} from '@/api/Product/Product'

export default {
    data() {
        return {
            loading: false,
            asinInfo: {},
            list: [],
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        flagStr: {
            type: String,
            default: ''
        },
        info: {
            type: Object,
            default: {}
        }
    },
    watch: {
        info: {
            handler(val) {
                this.asinInfo = val
            },
            deep: true,
        },
        visible: {
            handler(val) {
                if (val && this.flagStr == '店铺') {
                    api.shop_name_list().then(res => {
                        if (res.code === 0) {
                            this.list = res.data || []
                        }
                    }).catch(res => {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 关闭弹窗
        handleClose(callApi) {
            if (callApi == true) {
                let apiPromise = ''
                if (this.flagStr == '备注') {
                    apiPromise = track_asin_index_update_remark({id: this.asinInfo.id, remark: this.asinInfo.remark})
                } else if (this.flagStr == '负责人') {
                    apiPromise = track_asin_index_update_person({id: this.asinInfo.id, person: this.asinInfo.person})
                } else if (this.flagStr == '品牌') {
                    apiPromise = track_asin_index_update_brand({id: this.asinInfo.id, brand: this.asinInfo.brand})
                } else {
                    apiPromise = track_asin_index_update_shop_name({
                        id: this.asinInfo.id,
                        shop_name: this.asinInfo.shop_name
                    })
                }
                apiPromise.then(res => {
                    if (res.code === 0) {
                        this.$message({type: 'success', message: '更新成功'})
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(res => {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                })
            }

            this.$emit('close-callback', callApi !== true)
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>

